import AntdMenu from "antd/es/menu/MenuItem";

const MenuItem = AntdMenu;

export { MenuItem };
